<label>
  <textarea class="textarea-container" placeholder="{{ placeholder }}"> </textarea>
</label>
